import { getCampaignPostExclusionKey } from 'src/utils/campaign/campaign-post-exclusion';

/**
 * 포스트 메모의 **정체성 키** — 제외 등록과 같은 규칙(ES id, 없으면 `link:` + 정규화 링크).
 * 같은 글이면 어느 캠페인·어느 표에서 봐도 같은 메모를 찾아야 하므로 규칙을 둘로 두지 않는다.
 * @param {object} post
 * @returns {string} 키. 식별할 수 없으면 빈 문자열
 */
export function getPostMemoKey(post: unknown): string {
  return getCampaignPostExclusionKey(post);
}

/**
 * 키 → Firestore 문서 id. 링크 키는 `/` 를 품어 문서 id 로 못 쓰므로 URL 인코딩한다.
 * ⚠️ 문서에는 원래 키(`postKey`)를 따로 적는다 — 화면은 문서 id 를 되풀지 않는다.
 * @param {string} key
 * @returns {string}
 */
export function postMemoDocIdOf(key: string): string {
  return encodeURIComponent(String(key ?? '').trim());
}

/** 메모 본문 상한 — 서버가 이 길이로 자른다 */
export const POST_MEMO_MAX_LENGTH = 500;
